<!-- <div style="height: 54px; width: 100%; background-color: yellowgreen;">
	<marquee scrollamount="20" direction="left" style="text-align: center; color:tomato; font-size: 32px; line-height: 54px;">!!!! This Portion is reserved exclusive for HEADER !!!!</marquee>
</div> -->
<fplib-common-headers [isShowNotify]="false" [isSharedlayout]="false" [activeCurrentTheme]="'Dark'"></fplib-common-headers>

<router-outlet />

<fplib-common-footer [baseUrl]="baseUrl" [footerRoutesMenue]="footerMenues"></fplib-common-footer>